export default  {"src":"/_next/static/image/public/assets/nevo-boi/logo-large.fcc0a10e876c8d747c80d17f7d375f2b.svg","height":100,"width":384};